import BreadcrumbsAndViewBanner from '../breadcrumbs-and-view-banner/breadcrumbs-and-view-banner';
import React, { useContext } from 'react';
import { OwnerManualProps } from '../../pages/owner-manual/hook/use-owner-manual-content';
import { OwnerManualResponse } from '../../services/owner-manual-service/owner-manual-service';
import ServerContext from '../../../contexts/serverContext';
import { OwnerManualBreadcrumbLink } from '../../pages/owner-manual-sitemap/owner-manual-breadcrumb-link';

interface Props {
    currentRoot: any;
    ownerManualContent: OwnerManualProps;
    ownerManualData: OwnerManualResponse | null;
    vin: string;
    isAiSearch?: boolean;
}

const OwnerManualBreadCrumbs = (props: Props) => {
    const serverContext = useContext(ServerContext);
    const { ownerManualContent, ownerManualData, currentRoot, vin } = props;

    const yearAndModel =
        ownerManualData?.metadata.displayModelName &&
        ownerManualData?.metadata.modelYear
            ? `${ownerManualData?.metadata.displayModelName} ${ownerManualData?.metadata.modelYear}`
            : `${' '}`;

    return (
        <>
            <BreadcrumbsAndViewBanner
                currentPage={vin ? `${vin}` : yearAndModel}
                previousCrumb={
                    <OwnerManualBreadcrumbLink
                        ownerManualContent={ownerManualContent}
                        serverContext={serverContext}
                        currentRoot={currentRoot}
                    />
                }
                hashId={'support'}
                isAiSearch={props.isAiSearch}
                aiSearchContent={ownerManualContent}
            />
        </>
    );
};
export default OwnerManualBreadCrumbs;
